<template>
    <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg :headerText="lbl.platinumService.title.default" small logo sideMenu></TopBarBg>
        <PageContent class="flex-auto" :hasPoweredBy="hasPoweredBy">
            <div class="my-6 mx-18px">
                <PlatinumServiceCategoryList :modalController="modalController" @onLoaded="onLoaded()"></PlatinumServiceCategoryList>
            </div>
        </PageContent>
        <Footer :hasPoweredBy="hasPoweredBy" />
    </div>

    <div class="flyout-zone">
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue"
import PageContent from "@/components/Layout/Content/PageContent.vue"
import Footer from "@/components/Layout/Footer/Footer.vue"
import PlatinumServiceCategoryList from "../component/PlatinumServiceCategoryList.vue"
import ModalMaster from "@/components/Modal/ModalMaster.vue"

// mixins
import ModalMixin from "@/mixin/ModalMixin"
import LocaleMixin from "@/mixin/LocaleMixin"
import ErrorApiMixin from "@/mixin/ErrorApiMixin"
import PdpaMixin from "@/mixin/PdpaMixin";

export default {
    name: 'PlatinumServiceMainPage',
    props: {},
    components: {
        TopBarBg,
        PageContent,
        Footer,
        PlatinumServiceCategoryList,
        ModalMaster
    },
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin, PdpaMixin],
    emits: [],
    data: function () {
        return {
            hasPoweredBy: false,
            items: [],
            trackingScreenName: 'platinum_service',
        }
    },
    computed: {},
    created: function () { },
    mounted: function () {
        this.tracking.screenName(this.trackingScreenName);
        this.loadingModal.show()
    },
    methods: {
        onLoaded: function(){
            this.loadingModal.hide()
        }
    }
}
</script>
